import { render } from "./QuestionList.vue?vue&type=template&id=3129dc1d&scoped=true"
import script from "./QuestionList.vue?vue&type=script&lang=js"
export * from "./QuestionList.vue?vue&type=script&lang=js"

import "./QuestionList.vue?vue&type=style&index=0&id=3129dc1d&scoped=true&lang=css"

import exportComponent from "/tmp/pelican-managers-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3129dc1d"]])

export default __exports__